import {
  AppDialog as PlanningDialog,
  DialogStack as PlanningDialogStack,
  DrawerStack as PlanningDrawerStack,
} from '@tom-ui/planning'
import {
  ConfirmationDialogContainer as StorageConfirmationDialogContainer,
  useStorageStore,
} from '@tom-ui/storage'
import { AppLoader, SnackbarToast } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { ContainerMovementDialog } from './components/container-movement-dialog/ContainerMovementDialog'
import { PlanContainerPositionDialog } from './components/plan-container-position-dialog/PlanContainerPositionDialog'
import { Layout } from './Layout'

export const RootElement = observer(() => {
  const { confirmationDialogStore: storageConfirmationDialogStore } = useStorageStore()

  return (
    <Layout>
      <Outlet />
      <PlanningDrawerStack />
      <PlanningDialogStack />
      <PlanningDialog />

      <StorageConfirmationDialogContainer
        open={storageConfirmationDialogStore.isOpen}
        title={storageConfirmationDialogStore.title ?? ''}
        content={<>{storageConfirmationDialogStore.message}</>}
        onClose={() => storageConfirmationDialogStore.answer(false)}
        onConfirm={() => storageConfirmationDialogStore.answer(true)}
      />

      <ContainerMovementDialog />
      <PlanContainerPositionDialog />

      <AppLoader />
      <SnackbarToast />
    </Layout>
  )
})
